export const HttpStatusCode = {
  // Informational (1xx) - Request received, continuing process
  CONTINUE: 100, // Continue with request (Any method)
  SWITCHING_PROTOCOLS: 101, // Switching to different protocol (Any method)
  PROCESSING: 102, // Request is being processed (Any method)
  EARLY_HINTS: 103, // Preload resources before final response (Any method)

  // Successful (2xx) - Request successfully processed
  OK: 200, // Request was successful (GET/POST/PUT/DELETE)
  CREATED: 201, // Resource successfully created (POST/PUT)
  ACCEPTED: 202, // Request accepted, processing asynchronously (POST/PUT)
  NON_AUTHORITATIVE_INFORMATION: 203, // Response from another source (GET)
  NO_CONTENT: 204, // Request successful, but no content returned (DELETE/PUT)
  RESET_CONTENT: 205, // Reset document view (PUT)
  PARTIAL_CONTENT: 206, // Partial content returned (GET)

  // Redirection (3xx) - Further action needed
  MULTIPLE_CHOICES: 300, // Multiple options for resource (GET)
  MOVED_PERMANENTLY: 301, // Resource permanently moved (GET)
  FOUND: 302, // Resource temporarily moved (GET)
  SEE_OTHER: 303, // Redirect to another resource (GET)
  NOT_MODIFIED: 304, // Resource not changed, use cached version (GET)
  USE_PROXY: 305, // Must use a proxy (Any method)
  TEMPORARY_REDIRECT: 307, // Temporary redirect, same method (Any method)
  PERMANENT_REDIRECT: 308, // Permanent redirect, same method (Any method)

  // Client Errors (4xx) - Request has issues
  BAD_REQUEST: 400, // Invalid request syntax (Any method)
  UNAUTHORIZED: 401, // Authentication required (Any method)
  PAYMENT_REQUIRED: 402, // Payment required (Any method)
  FORBIDDEN: 403, // Access denied (Any method)
  NOT_FOUND: 404, // Resource not found (Any method)
  METHOD_NOT_ALLOWED: 405, // HTTP method not allowed (Any method)
  NOT_ACCEPTABLE: 406, // Content not acceptable (Any method)
  PROXY_AUTHENTICATION_REQUIRED: 407, // Proxy authentication needed (Any method)
  REQUEST_TIMEOUT: 408, // Request timed out (Any method)
  CONFLICT: 409, // Conflict in request (PUT/POST)
  GONE: 410, // Resource permanently removed (GET)
  LENGTH_REQUIRED: 411, // Content-Length header required (Any method)
  PRECONDITION_FAILED: 412, // Precondition check failed (Any method)
  PAYLOAD_TOO_LARGE: 413, // Request body too large (POST/PUT)
  URI_TOO_LONG: 414, // URI is too long (GET)
  UNSUPPORTED_MEDIA_TYPE: 415, // Media type not supported (POST/PUT)
  RANGE_NOT_SATISFIABLE: 416, // Requested range not valid (GET)
  EXPECTATION_FAILED: 417, // Expectation in request header failed (Any method)
  I_AM_A_TEAPOT: 418, // Joke status code (Any method)
  MISDIRECTED_REQUEST: 421, // Request sent to wrong server (Any method)
  UNPROCESSABLE_ENTITY: 422, // Validation failed (POST/PUT)
  LOCKED: 423, // Resource is locked (Any method)
  FAILED_DEPENDENCY: 424, // Dependent request failed (Any method)
  UPGRADE_REQUIRED: 426, // Upgrade protocol required (Any method)
  PRECONDITION_REQUIRED: 428, // Precondition header required (Any method)
  TOO_MANY_REQUESTS: 429, // Too many requests, rate limit exceeded (Any method)
  REQUEST_HEADER_FIELDS_TOO_LARGE: 431, // Header fields too large (Any method)
  UNAVAILABLE_FOR_LEGAL_REASONS: 451, // Blocked for legal reasons (Any method)

  // Server Errors (5xx) - Server failed to process request
  INTERNAL_SERVER_ERROR: 500, // Generic server error (Any method)
  NOT_IMPLEMENTED: 501, // Server does not support request method (Any method)
  BAD_GATEWAY: 502, // Invalid response from upstream server (Any method)
  SERVICE_UNAVAILABLE: 503, // Server temporarily unavailable (Any method)
  GATEWAY_TIMEOUT: 504, // Upstream server timed out (Any method)
  HTTP_VERSION_NOT_SUPPORTED: 505, // HTTP version not supported (Any method)
  VARIANT_ALSO_NEGOTIATES: 506, // Negotiation failed (Any method)
  INSUFFICIENT_STORAGE: 507, // Server storage limit exceeded (Any method)
  LOOP_DETECTED: 508, // Infinite loop detected (Any method)
  NOT_EXTENDED: 510, // Additional extensions required (Any method)
  NETWORK_AUTHENTICATION_REQUIRED: 511, // Network authentication required (Any method),
};
